import React from "react";
import "./LikeButton.css";

const ShareButton = ({ postTitle, postUrl }) => {
    const handleShare = async () => {
        const shareData = {
            title: postTitle,
            text: "看看這篇文章！",
            url: postUrl,
        };

        try {
            if (navigator.share) {
                await navigator.share(shareData);
            } else {
                await navigator.clipboard.writeText(shareData.url);
                alert("連結已複製！");
            }
        } catch (err) {
            console.error("分享失敗:", err);
        }
    };

    return (
        <button className="share-button" onClick={handleShare}>
            <svg
                className="share-icon"
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
            >
                <path
                    d="M7.39999 6.32003L15.89 3.49003C19.7 2.22003 21.77 4.30003 20.51 8.11003L17.68 16.6C15.78 22.31 12.66 22.31 10.76 16.6L9.91999 14.08L7.39999 13.24C1.68999 11.34 1.68999 8.23003 7.39999 6.32003Z"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M10.11 13.6501L13.69 10.0601"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </svg>
            分享
        </button>
    );
};

export default ShareButton;
